'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = exports.formatTime = exports.formatDate = exports.formatMessage = exports.initializeFormatMessage = undefined;

var _reactIntl = require('react-intl');

var intl = void 0;

/**
 * Initializes static intlProvider's intl context object for formatMessage
 * Should be called once when locale messages are all downloaded and ready
 * @param {string} locale 
 * @param {string} defaultLocale 
 * @param {Object} messages 
 */
var initializeFormatMessage = exports.initializeFormatMessage = function initializeFormatMessage(locale, defaultLocale, messages) {
  // https://github.com/yahoo/react-intl/issues/416
  var intlProvider = new _reactIntl.IntlProvider({ defaultLocale: defaultLocale, locale: locale, messages: messages }, {});
  intl = intlProvider.getChildContext().intl;
};

/**
 * @param {any} value 
 * @param {any} [options]
 * @returns {string}
 */
var formatMessage = exports.formatMessage = function formatMessage(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (!intl) {
    // if not initialized correctly, gracefully initialize with 
    // english defaults and move on. This is mainly for unit tests
    // This should not be getting hit at runtime
    initializeFormatMessage('en-US', 'en-US', undefined);
  }

  return intl.formatMessage(value, options);
};

/**
 * @param {any} value 
 * @param {any} [options]
 * @returns {string}
 */
var formatDate = exports.formatDate = function formatDate(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (!intl) {
    // if not initialized correctly, gracefully initialize with 
    // english defaults and move on. This is mainly for unit tests
    // This should not be getting hit at runtime
    initializeFormatMessage('en-US', 'en-US', undefined);
  }

  return intl.formatDate(value, options);
};

/**
 * @param {any} value 
 * @param {any} [options]
 * @returns {string}
 */
var formatTime = exports.formatTime = function formatTime(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (!intl) {
    // if not initialized correctly, gracefully initialize with 
    // english defaults and move on. This is mainly for unit tests
    // This should not be getting hit at runtime
    initializeFormatMessage('en-US', 'en-US', undefined);
  }

  return intl.formatTime(value, options);
};

/**
 * @param {any} value 
 * @param {any} [options]
 * @returns {string}
 */
var formatNumber = exports.formatNumber = function formatNumber(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (!intl) {
    // if not initialized correctly, gracefully initialize with 
    // english defaults and move on. This is mainly for unit tests
    // This should not be getting hit at runtime
    initializeFormatMessage('en-US', 'en-US', undefined);
  }

  return intl.formatNumber(value, options);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/IntlService.js
// module id = 220
// module chunks = 10